import { SozUndArbeitsAnamneseLeer } from '../anamnese/SozUndArbeitsAnamneseLeer';
import { s3ReadFile, s3ListObjects } from '../s3Utils';

export function readData(massnahmeid, storeFN) {
    const handleS3Daten = (result) => {
        const keys = Object.keys(result);
        if (keys.includes('SozUBeruf.txt')) {
            s3ReadFile('SozUBeruf.txt', 'private', storeFN)
        } else {
            // console.log('File not found, using SozUndArbeitsAnamneseLeer')
            storeFN(SozUndArbeitsAnamneseLeer);
        }
    }

    s3ListObjects('', 'private', handleS3Daten);
}